import {configureStore} from '@reduxjs/toolkit';


import {SubscriptionsReducer} from "../features/billing-management/subscriptions/reducers";
import {UserProfileAttributesReducer} from "../features/users-management/user-profile-attributes/reducers";
import {OrganizationsReducer} from "../features/accounts-management/organizations/reducers";

import {AccountsReducer} from "../features/accounts-management/accounts/reducers";
import {AccountApplicationsReducer} from "../features/accounts-management/account-applications/reducers";
import {ApplicationsReducer} from "../features/accounts-management/applications/reducers";

const reducers = {
    userProfileAttributes: UserProfileAttributesReducer,
    subscriptions: SubscriptionsReducer,
    organizations: OrganizationsReducer,
    accounts: AccountsReducer,
    accountApplications: AccountApplicationsReducer,
    applications: ApplicationsReducer
};

// FNP-336: dropped the `: Store` annotation. The annotation narrowed
// store.dispatch to plain Dispatch<UnknownAction> (no thunk overload) AND
// erased per-slice state typing. configureStore's inferred type is correct
// — ThunkDispatch is included automatically — so AppDispatch is just
// typeof store.dispatch.
export const store = configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});


export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
